import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default function setReviewsSwiper() {
  const sections = document.querySelectorAll('[data-reviews]');
  sections.forEach((section) => {
    const swiperEl = section.querySelector('.swiper');
    const next = section.querySelector('.swiper-button-next');
    const prev = section.querySelector('.swiper-button-prev');
    const pagination = section.querySelector('.swiper-pagination');

    if (swiperEl) {
      const slider = new Swiper(swiperEl, {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        spaceBetween: 8,
        speed: 1000,
        watchOverflow: true,
        centerInsufficientSlides: true,
        pagination: {
          el: pagination,
          type: 'bullets',
          clickable: true,
        },
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          991: {
            slidesPerView: 3,
          },
        },
      });
    }
  });
}
